import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  TextInput,
  TextField,
  EditButton,
  BulkDeleteButton,
  DeleteButton,
  FunctionField,
} from "react-admin";
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);
const ListActionButtons = ({ ...props }) => {
  return (
    <>
      <BulkDeleteButton
        {...props}
        undoable={false}
        confirmTitle="Delete File Record"
        confirmContent={"Are you sure you want to delete this record?"}
      />
    </>
  );
};
const CategoryListList = ({ ...props }) => {
  return (
    <List
      {...props}
      title="Category"
      bulkActionButtons={<ListActionButtons />}
      filters={<ListFilter />}

    >
      <Datagrid rowClick={"show"}>
        <TextField source="id" />
        <TextField source="name" label="Category Name" />
        <FunctionField source="status" label="Status" render={record => {
          if (record['status'] === 'Deactive') {
            return (<span style={{ color: 'red' }}>Deactive</span>)
          } else {
            return (<span style={{ color: 'green' }}>Active</span>)
          }
        }} />
        <TextField source="description" label="Description" />
        <TextField source="amount" label="Amount" />
        {useCheckPermissions('CategoryList_Edit')?<EditButton />:null}
        {useCheckPermissions('CategoryList_View')?<DeleteButton />:null}
      </Datagrid>
    </List>
  );
};

export default CategoryListList;
